import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { SSRConfig } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import PrivateRoute from '@/lib/private-route';
import { cleanObject } from '@/lib/utils';
import Layout from '@/modules/core/components/Layout';
import useDisplayMessage from '@/modules/core/hooks/useDisplayMessage';
import useProfile from '@/modules/core/hooks/useProfileHook';
import { IUserData } from '@/modules/core/types';
import MessagesTab from '@/modules/profile/components/MessagesTab';
import MyAlertsTab from '@/modules/profile/components/MyAlertsTab';
import MyListings from '@/modules/profile/components/MyListingsTab';
import ProDashboardTab from '@/modules/profile/components/ProDashboardTab/ProDashboardTab';
import ProfileDetailsTab from '@/modules/profile/components/ProfileDetailsTab';
import ProfileSidePanel from '@/modules/profile/components/ProfileSidePanel';
import SecurityTab from '@/modules/profile/components/SecurityTab';
import TransactionHistoryTab from '@/modules/profile/components/TransactionHistoryTab';
import useTabs from '@/modules/profile/hooks/useTabs';
import { ITabs, UserType } from '@/modules/profile/types';

// type ListingItemPageProps =
//   | ListingItemPageActiveProps
//   | ListingItemPageDeletedProps;

// interface ListingItemPageDeletedProps extends SSRConfig {
//   adDeleted: ListingState;
// }
// interface ListingItemPageActiveProps extends SSRConfig {
//   adDetails: IAdDetailItem;
//   adUserData: IUserData;
// }

const Profile = () => {
  const {
    adsListData,
    loadMoreAdsList,
    balance,
    transactionList,
    updateUserState,
    userState,
    userData,
    onClickUpdateUserData,
    passwordTab,
    updatePasswordTab,
    updatePassword,
    countAds,
    savedSearchList,
  } = useProfile();

  // const { adDetails, adUserData } =
  //   props as ListingItemPageActiveProps;

  // console.log(adUserData)

  // const { adDetails, adUserData } =
  //   props as ListingItemPageActiveProps;

  // console.log(adDetails)

  const Tabs: ITabs = {
    dashboard:
      userData.userType === UserType.PRO ? (
        <ProDashboardTab
          classifieds={adsListData}
          userData={userData}
          balance={balance}
          transactionList={transactionList}
          alerts={savedSearchList}
        />
      ) : (
        <>
          <div className="w-fit h-fit my-10 mx-auto flex flex-col  justify-center  align-middle items-center  rounded-lg text-xs ">
            <img
              src="/media/dashboardNotFound.png"
              className="w-[40%] h-fit"
              alt="tayara illustration : dashboard not found "
            />
            <p className="text-gray-700 my-24 mx-auto font-bold text-lg text-center align-middle">
              Si vous êtes un pro et vous ne pouvez pas accéder à votre
              dashboard, veuillez contacter notre{' '}
              <a
                target="_blank"
                className="underline font-bold text-info hover:no-underline"
                href="https://www.tayara.tn/contact/"
                rel="noreferrer"
              >
                équipe support tayara.
              </a>
            </p>
          </div>
        </>
      ),
    myListings: (
      <MyListings
        balance={balance}
        adlist={adsListData}
        loadMoreAds={loadMoreAdsList}
        countAds={countAds}
      />
    ),
    messages: <MessagesTab />,
    myAlerts: <MyAlertsTab alerts={savedSearchList} />,
    transactions: (
      <TransactionHistoryTab
        balance={balance}
        transactionList={transactionList}
      />
    ),
    details: (
      <ProfileDetailsTab
        username={userState?.fullname}
        email={userState?.email}
        phone={userState?.phone}
        updateUserState={updateUserState}
        onClickSubmit={onClickUpdateUserData}
      />
    ),
    security: (
      <SecurityTab
        oldPassword={passwordTab?.oldPassword}
        password={passwordTab?.password}
        repassword={passwordTab?.repassword}
        onSubmit={updatePassword}
        updatePasswordTab={updatePasswordTab}
      />
    ),
  };

  const [, { currentTab, currentTabKey }] = useTabs(
    userData.userType === UserType.PRO ? 'dashboard' : 'myListings',
    Tabs
  );

  const [DisplaySuccess, DisplayError] = useDisplayMessage(
    currentTabKey,
    'profile'
  );
  return (
    <>
      <div className="pb-6 px-1 lg:px-4 md:-ml-4">
        <div className="">
          <div className="divide-y divide-gray-200 lg:divide-y-0  lg:divide-x">
            {/* Profile section */}
            <div className="py-6 px-2 sm:p-6 lg:pb-8 min-h-screen mt-2 lg:mt-0 ">
              {currentTab}

              {DisplayError}
              {DisplaySuccess}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Layout configuration
Profile.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <PrivateRoute>
        <Layout.WithSidePanel
          aside={<ProfileSidePanel userData={{} as IUserData} />}
        >
          {page}
        </Layout.WithSidePanel>
      </PrivateRoute>
    </Layout>
  );
};

export default Profile;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
}): Promise<GetServerSidePropsResult<SSRConfig>> => ({
  props: cleanObject({
    ...(await serverSideTranslations(locale || 'en')),
  }),
});

// export const getServerSideProps: GetServerSideProps = async ({
//   locale,
//   res, req,
// }): Promise<GetServerSidePropsResult<ListingItemPageProps>> => {
//   const localeData = await serverSideTranslations(locale || 'en');

//   let ad: any;
//   const [user] = await Promise.all([
//     getUser(ad?.getAd()?.getUserid())
//   ]);
//   const iAdDetailItem = mapAdResponseToDetails(ad);

//   const cookies = new Cookies(req, res);
//   const reqUserId = cookies.get('userid');
//   const adOwnerUserId = ad?.getAd()?.getUserid();
//   const authorizedToViewAd = reqUserId === adOwnerUserId;

//   if (
//     ![ListingState.ACTIVE, ListingState.PENDING_INSERTION].includes(
//       iAdDetailItem.state
//     ) &&
//     !authorizedToViewAd
//   ) {
//     res.statusCode = 410;
//     return {
//       props: {
//         ...localeData,
//         adDeleted: iAdDetailItem.state,
//       },
//     };
//   }

//   return {

//   props: cleanObject({
//     ...(await serverSideTranslations(locale || 'en')),
//     adDetails: mapAdResponseToDetails(ad),
//     adUserData: mapUserResponseToIUserData(user),
//   }),
// }
// }
